// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Qo9yx","right":"styles_right__3aDoU"};